import React, { useContext } from 'react';
import { Picture, Img } from '@xo-union/tk-component-picture';
import { Theme } from './ThemeCard';
import { TrackingContext } from '../../TrackingContext';
import classNames from 'classnames';

import styles from './swatch.scss';
import useBuildThemeAnalyticsBaseProps from '../../hooks/useBuildThemeAnalyticsBaseProps';

interface SwatchProps {
  familyTheme: Theme;
  onClick?: (themeId: number) => void;
  selected?: boolean;
  isCurrentTheme?: boolean;
}

const Swatch: React.FC<SwatchProps> = ({ familyTheme, onClick, selected = false, isCurrentTheme = false }) => {
  const { track } = useContext(TrackingContext);
  const { getThemeAnalyticsBaseProps } = useBuildThemeAnalyticsBaseProps();

  const clickHandler = () => {
    if (onClick && !selected && familyTheme?.id) {
      onClick(familyTheme?.id);
      track('Design Previewed', {
        ...getThemeAnalyticsBaseProps(familyTheme),
        selection: 'colorway swatch',
      });
    }
  };

  const mediaApiId = familyTheme?.swatchImage?.mediaApiId;
  return (
    <div
      className={classNames(styles.swatch, {
        [styles.swatch__selected]: selected || isCurrentTheme,
      })}
      data-testid={`swatch-${selected ? 'selected-' : ''}${isCurrentTheme ? 'featured-' : ''}${familyTheme?.id}`}
      onClick={clickHandler}
      title={familyTheme?.name || ''}
    >
      <div className={styles.swatchImageMask}>
        <Picture id={mediaApiId} slug="colorway-swatch" lazy alt="" className={styles.swatchImage}>
          <Img width={20} />
        </Picture>
      </div>
    </div>
  );
};

export default Swatch;
